import { j as s } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as t } from "react";
import { I as a } from "../../../../IconBase-CxZyIWw2.js";
const i = t((r, e) => /* @__PURE__ */ s.jsx(
  a,
  {
    ref: e,
    ...r,
    image: (o) => /* @__PURE__ */ s.jsxs(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...o,
        children: [
          /* @__PURE__ */ s.jsx(
            "mask",
            {
              id: "mask0_2974_3516",
              width: 17,
              height: 12,
              x: 0,
              y: 2,
              maskUnits: "userSpaceOnUse",
              style: {
                maskType: "alpha"
              },
              children: /* @__PURE__ */ s.jsx(
                "path",
                {
                  fill: "currentColor",
                  d: "M15.25 7.21H3.75C5 6.28 6.19 4.85 6.19 2.75c0-.41-.34-.75-.75-.75s-.75.34-.75.75C4.69 5.94.58 7.2.54 7.21a.73.73 0 0 0-.54.73c.01.34.24.63.57.71.17.04 4.07 1.07 4.07 4.52 0 .41.34.75.75.75s.75-.34.75-.75c0-2.02-1.01-3.48-2.22-4.46h11.34c.41 0 .75-.34.75-.75s-.35-.75-.76-.75"
                }
              )
            }
          ),
          /* @__PURE__ */ s.jsx("g", { mask: "url(#mask0_2974_3516)", children: /* @__PURE__ */ s.jsx("path", { fill: "currentColor", d: "M0 0h16v16H0z" }) })
        ]
      }
    )
  }
));
i.displayName = "AgencyArrowLeftIcon";
export {
  i as AgencyArrowLeftIcon,
  i as default
};
//# sourceMappingURL=index.js.map
